import Transform from "@ember-data/serializer/transform";

export default class HormonotherapiesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(hormonotherapy => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (hormonotherapy.startDate) {
        hormonotherapy.startDate = new Date(hormonotherapy.startDate);
      }
      if (hormonotherapy.endDate) {
        hormonotherapy.endDate = new Date(hormonotherapy.endDate);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    hormonotherapies: HormonotherapiesTransform;
  }
}
